import {
	ContactSignInType,
	SignInKioskCompanyContactsToNotify,
	SignInPages,
	SignOutPages,
} from "./sign-in-kiosk.state";

export class ConfigureAsKiosk {
	static readonly type = "[Sign-in-kiosk] Configure As Kiosk";
	constructor(public payload: { slug: string; device?: string; redirect?: boolean }) {}
}
export class BackToStart {
	static readonly type = "[Sign-in-kiosk] Back To Start";
}
export class SetSignInType {
	static readonly type = "[Sign-in-kiosk] Set Sign In Type";
	constructor(public payload: ContactSignInType) {}
}
export class SetCompanyContactToNotify {
	static readonly type = "[Sign-in-kiosk] Set Company Contact To Notify";
	constructor(public payload: SignInKioskCompanyContactsToNotify) {}
}
export class Search {
	static readonly type = "[Sign-in-kiosk] Search";
	constructor(
		public payload: {
			mobile: string;
		},
	) {}
}
export class SearchSignedInContacts {
	static readonly type = "[Sign-in-kiosk] Search Signed In Contacts";
	constructor(
		public payload: {
			mobile: string;
		},
	) {}
}
export class RegisterContact {
	static readonly type = "[Sign-in-kiosk] Register Contact";
	constructor(
		public payload: {
			FirstName: string;
			LastName: string;
			PrimaryEmail: string;
			CompanyName: string;
			PrimaryContactNumber: string;
		},
	) {}
}
export class SignIn {
	static readonly type = "[Sign-in-kiosk] Sign In";
	constructor(
		public payload: {
			imageURL?: string;
			signature?: string;
			formItems?: Record<string, any>;
		},
	) {}
}
export class SignOut {
	static readonly type = "[Sign-in-kiosk] Sign Out";
	constructor(
		public payload: {
			imageURL: string;
		},
	) {}
}
export class StartInduction {
	static readonly type = "[Sign-in-kiosk] Start Induction";
	constructor(
		public payload: {
			inductionID: string;
		},
	) {}
}
export class ResumeInduction {
	static readonly type = "[Sign-in-kiosk] Resume Induction";
	constructor(
		public payload: {
			referenceID: string;
			parentInductionID: string;
		},
	) {}
}
export class GetPortalDetails {
	static readonly type = "[Sign-in-kiosk] Get Portal Details";
}
export class GetContactAttempts {
	static readonly type = "[Sign-in-kiosk] Get Contact Attempts";
}
export class GetCompanyContactsToNotify {
	static readonly type = "[Sign-in-kiosk] Get Company Contacts To Notify";
}
export class Print {
	static readonly type = "[Sign-in-kiosk] Print";
}
export class SetSignInFlow {
	static readonly type = "[Sign-in-kiosk] Set Sign In Flow";
	constructor(public payload: SignInPages[]) {}
}
export class SetSignOutFlow {
	static readonly type = "[Sign-in-kiosk] Set Sign Out Flow";
	constructor(public payload: SignOutPages[]) {}
}
